<!-- Base Filter Widget -->
@if (visible) {
  <div>
    <div class="filter-container">
    </div>
    <div class="filter-header">
      FILTERS
      <mat-icon class="filter-close" (click)="onCloseFilterClick()">close</mat-icon>
    </div>
    <div class="filter filter-saved">
      <div class="label">SAVED FILTERS</div>
      <div class="btn-group" dropdown>
        <button id="button-basic" dropdownToggle type="button" class="btn btn-primary field "
          [ngClass]="{'dropdown-toggle': stateService.savedReportFilters.length > 0}"
          aria-controls="dropdown-basic"
          (click)="onFilterSaveClick(false)">
          {{getFilterSaveDropDownText()}}
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
          @for (filter of stateService.savedReportFilters; track filter) {
            <li
              class="dropdown-item"
              (click)="onFilterSaveOptionClick(filter)"
              role="menuitem">
              {{filter.name}}
              @if (filter.allowDelete) {
                <mat-icon
                  class="icon delete-icon"
                  (click)="onRemoveSavedFilterClick($event, filter)">
                  delete
                </mat-icon>
              }
            </li>
          }
        </ul>
      </div>
      @if (selectedSavedFilterSet) {
        <div class="field filter-default">
          Make Default
          <mat-slide-toggle
            class="toggle"
            [checked]="selectedSavedFilter.default"
            (toggleChange)="onFilterDefaultChanged()">
          </mat-slide-toggle>
        </div>
      }
      <div class="label">ACTIVE FILTERS</div>
      @for (filter of activeReportFilters; track filter) {
        <div class="field"
          style="margin-bottom: 5px;"
          [ngClass]="{'field-expanded' : getFilterText(filter).length > 25}"
          >
          <div class="new" (click)="onActiveFilterClick(filter)">
            <table>
              <tr>
                <td width="185px">
                  {{getFilterText(filter)}}
                </td>
                <td>
                  @if (!selectedSavedFilterSet) {
                    <mat-icon class="icon" (click)="onRemoveFilterClick(filter)">close</mat-icon>
                  }
                </td>
              </tr>
            </table>
          </div>
        </div>
      }
      @if (!selectedSavedFilterSet) {
        <div class="field" (click)="onAddFilterClick()">
          <div class="new">
            Add Filter
            <mat-icon class="icon">add</mat-icon>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Add Filter Widget -->
@if (filterEditorVisible) {
  <div>
    <div class="filter-container filter-new">
    </div>
    <div class="filter-header filter-new">
      {{filterMode}} FILTER
      <mat-icon class="filter-close" (click)="onCloseAddFilterClick()">close</mat-icon>
    </div>
    <div class="filter filter-add">
      <div class="label">FIELD</div>
      <div class="btn-group" dropdown>
        <button #filterfield id="filterField" dropdownToggle type="button" class="btn btn-primary dropdown-toggle field"
          [ngClass]="{'disabled': locked===true}"
          aria-controls="dropdown-fields">
          {{defaultFieldValue}}
          <span class="caret"></span>
        </button>
        <ul id="dropdown-fields" *dropdownMenu class="dropdown-menu"
          role="menu" aria-labelledby="filterField">
          @for (field of report.filters; track field) {
            <li role="menuitem">
              @if (notExistingFilter(field)) {
                <a class="dropdown-item" (click)="onFilterFieldClick(field)">{{field.name}}</a>
              }
            </li>
          }
        </ul>
      </div>
      <div class="label">OPERATOR</div>
      <div class="btn-group" dropdown>
        <button #operatorfield id="operatorField" dropdownToggle type="button" class="btn btn-primary dropdown-toggle field"
          aria-controls="dropdown-fields">
          {{defaultOperatorValue}}
          <span class="caret"></span>
        </button>
        <ul id="dropdown-fields" *dropdownMenu class="dropdown-menu"
          role="menu" aria-labelledby="operatorField">
          @for (operator of operators; track operator) {
            <li role="menuitem">
              <a class="dropdown-item" (click)="onOperatorFieldClick(operator)">{{operator.key}}</a>
            </li>
          }
        </ul>
      </div>
      <div class="label">VALUE</div>
      <!-- <ng-container *ngFor="let value of chosenFilter.values; let i=index"> -->
      @if (!isSearchableOperator) {
        @for (value of chosenFilter.values; track value; let i = $index) {
          <input
            [id]="getValueFieldName(i)"
            autocomplete="off"
            class="filter-value field"
            style="margin-bottom: 3px;">
        }
      }
      @if (isSearchableOperator) {
        @for (value of chosenFilter.values; track value; let i = $index) {
          <ngx-select-dropdown
            class="field"
            selection=undefined,
            id="{{getValueFieldName(i)}}"
            (change)="onDropdownValueSelectionChanged(i, $event)"
            (searchChange)="onDropdownValueSearchChanged(i, $event)"
            [config]="dropdownConfig"
            [options]="dropdownOptions"
            [selectedItem]="getValueFieldSelectedItem(i)"
            [searchText]="dropdownSearchText">
          </ngx-select-dropdown>
        }
      }
    <!-- </ng-container> -->
    <button mat-button class="filter-add-button" (click)="onFilterApplyClick()">{{filterMode}}</button>
  </div>
</div>
}
<app-report-filter-new></app-report-filter-new>
